import { useState } from "react";
import styles from "./RequestAssessment.module.scss";
import { ModalOverlay } from "../ModalOverlay";
import { useMutation } from '@apollo/client';
import { ASSESSMENTS_INVITES, SEND_ASSESSMENT_INVITE_REMINDER, TAG_SUGGESTIONS } from '../../apollo/queries';
import { AssessmentInviteReminderForm } from '../AssessmentInviteReminderForm';
import { client } from '../../apollo/client';

type RequestAssessmentRoutes = {
    isOpen: boolean,
    onOpenChange: Function
    reminderContent: {
        id: number
        founderName: String
    }
}


export const RemindAssesssment = ({
    onOpenChange,
    isOpen = false,
    reminderContent
}: RequestAssessmentRoutes) => {
  const [sendingSuccessful, setSendingSuccessful] = useState(false);
  const [errorFound, setErrorFound] = useState(false);

    const [sendInviteReminderAction] = useMutation(SEND_ASSESSMENT_INVITE_REMINDER, {
        onCompleted: (data) => {
            if(data !== null && data.sendInviteReminder.code === 200) {
                setSendingSuccessful(true)
                setErrorFound(false)
                client.refetchQueries({
                    include: [ASSESSMENTS_INVITES]
                })
                setTimeout(() => {
                    onOpenChange(!isOpen);
                    setSendingSuccessful(false)
                }, 1500)
            }
        },
        onError: () => {
            setErrorFound(true)
            setTimeout(() => {
                onOpenChange(!isOpen);
                setSendingSuccessful(false)
                setErrorFound(false)
            }, 2500)
        }
    });

  const handleSendEmail = async (message: String) => {
      sendInviteReminderAction({
        variables: {
            message,
            assessmentInviteId: reminderContent.id
        },
    })
  };

  const handleOpenSend = () => {
      onOpenChange(!isOpen);
  };


    return (
    <div className={styles.wrapper}>
      <ModalOverlay show={isOpen}>
        <AssessmentInviteReminderForm
          isOpen={isOpen}
          onToggle={handleOpenSend}
          onClick={handleSendEmail}
          sendingSuccessful={sendingSuccessful}
          // @ts-ignore
          row={reminderContent}
          errorFound={errorFound}
        />
      </ModalOverlay>
    </div>
  );
};
